import axios from 'axios'

import config from '../../config'

const createFacility = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/Facilities`
  return axios.post(url, data)
}

export default createFacility
